module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', [_c('c-content', {
    staticClass: "hardware-content"
  }, [(_vm.banners.length > 0) ? _c('c-swipe', {
    attrs: {
      "images": _vm.banners,
      "auto": 0
    },
    on: {
      "click": _vm.bannerClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.closeTakeTicket && _vm.ticketCount > 0) ? _c('c-cell-container', {
    staticStyle: {
      "margin": "5px 0"
    }
  }, [_c('c-cell', {
    attrs: {
      "title": '您有%s张购物券可领取'.replace('%s', _vm.ticketCount),
      "icon": require('@/assets/images/hardware-market/clip-8@2x.png'),
      "theme-name": _vm.cellThemeName
    },
    nativeOn: {
      "click": function($event) {
        _vm.goodsTicket($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('c-thum', {
    attrs: {
      "items": _vm.goodsItem
    },
    on: {
      "click": _vm.goodsItemClick
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "thum-title"
        }, [_vm._v(_vm._s(props.obj.title))]), _vm._v(" "), _c('div', {
          staticClass: "thum-price"
        }, [_vm._v(_vm._s(_vm._f("currency0")(props.obj.price)))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9dc9ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/hardware-market/index.vue
// module id = 1053
// module chunks = 2